
const GlobalImage = ({ src, className,alt='' }) => {
    const domain = 'https://ucloudqn.unipus.cn/uai-website/'; // 设置你的图片域名
  return <img className={className } src={`${domain}${src}`} alt={alt} />;
  };

  export default GlobalImage 